import { translate } from "../../util/translate"

export const realEstateBranchHeaders = [
  {
    text: translate['customer.branches.label.name'],
    value: 'name',
    width: '300',
  },
  {
    text: translate['customer.branches.label.city'],
    value: 'city',
    width: '180',
  },
  {
    text: translate['customer.branches.label.address'],
    value: 'address',
    width: '400',
  },
  {
    value: 'is_headquarter',
    width: '50',
  },
  { value: 'actions', align: 'end', width: '100' },
]
